import React, { useState } from 'react';
import CustomerSearchBox from './CustomerSearchBox';

export default function CustomerPicker({ customer, onSelect }) {
  const [changing, setChanging] = useState(false);

  if (customer && !changing) {
    return (
      <div className="buyer-summary">
        <div className="buyer-summary-grid">
          <div><span className="muted">نام: </span><b>{customer.name}</b></div>
          <div><span className="muted">شماره ملی/ثبت: </span>{customer.national || '-'}</div>
          <div><span className="muted">شماره اقتصادی: </span>{customer.eco || '-'}</div>
          <div><span className="muted">کد پستی: </span>{customer.postal || '-'}</div>
          <div><span className="muted">استان/شهر: </span>{[customer.province, customer.city].filter(Boolean).join(' - ') || '-'}</div>
          <div><span className="muted">تلفن: </span>{customer.phone || '-'}</div>
          <div className="field-full"><span className="muted">نشانی: </span>{customer.address || '-'}</div>
        </div>
        <div className="flexend">
          <button type="button" className="btn secondary small" onClick={() => setChanging(true)}>
            <i className="fa-solid fa-user-pen" /> تغییر مشتری
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      <CustomerSearchBox
        onSelect={(c) => {
          onSelect(c);
          setChanging(false);
        }}
      />
      {customer && (
        <button type="button" className="btn secondary small" onClick={() => setChanging(false)}>
          <i className="fa-solid fa-xmark" /> انصراف
        </button>
      )}
    </>
  );
}
